// @ts-nocheck
import React, { FC } from "react";
import {
  Download, ExternalLink,
} from "lucide-react";
import {
  DefinitionTooltip,
  DashboardDataTablePanel,
  DashboardDataTablePanelHeader,
  DashboardDataTableSearch,
  DashboardDataTableScroll,
  DashboardDataTableSortButton,
  DashboardDataTableTable,
  TablePagePagination,
  toggleTableSort,
  dashboardDataTable as dt,
} from "src/components/common";
import {
  formatOrganicPostTypeLabel,
  getOrganicContentSectionDefinitionInfo,
  getOrganicPlatformMetricDefinitionInfo,
} from "../OrganicMediaDefinitions";
import PostMediaThumb from "../PostMediaThumb";
import { formatNumber } from "src/utils/numberFormat";
import {
  withBidiIsolate,
} from "./InstagramContentHelpers";
import "../../../styles/InstagramContentReport/InstagramContentPostTable.scss";

const InstagramContentPostTable: FC<{ props: Record<string, unknown> }> = ({ props }) => {
  const {
    t, i18n, sortedPostDetails, postTableSearch, setPostTableSearch, handleExportPosts,
    setPostTableSort, getCaptionPreview,
    truncateCaption, currentPostPage, setCurrentPostPage,
    totalPostPages, exportPostDetails,
  } = props;
  return (
    <div
      className="organic-content-report__post-table-block"
      data-pdf-block="post-table"
      data-pdf-splittable
    >
      <div className="organic-post-details organic-post-details--modern">
        <DashboardDataTablePanel>
        <DashboardDataTablePanelHeader>
          <div className="organic-content-panel__title">
            <h3>{t("organicMedia.instagram.sections.postLevelPerformance")}</h3>
            <DefinitionTooltip
              label={t("organicMedia.instagram.sections.postLevelPerformance")}
              info={getOrganicContentSectionDefinitionInfo("postLevelPerformance", t)}
              formulaTitle={t("organicMedia.common.formula")}
            />
          </div>
          <div className="organic-post-details__table-toolbar">
            <DashboardDataTableSearch
              value={postTableSearch}
              onChange={event => setPostTableSearch(event.target.value)}
              placeholder={t("organicMedia.contentReport.searchPostsByCaption")}
            />
            <button
              type="button"
              className="organic-post-details__export-button"
              onClick={handleExportPosts}
              disabled={sortedPostDetails.length === 0}
            >
              <Download size={14} aria-hidden />
              {t("organicMedia.contentReport.exportCsv")}
            </button>
          </div>
        </DashboardDataTablePanelHeader>
        <DashboardDataTableScroll className="organic-post-details__table-wrap">
          <DashboardDataTableTable className="organic-post-details__table organic-post-details__table--modern">
            <colgroup>
              <col className="organic-post-details__col-post" />
              <col className="organic-post-details__col-metric" />
              <col className="organic-post-details__col-metric" />
              <col className="organic-post-details__col-metric" />
              <col className="organic-post-details__col-metric" />
              <col className="organic-post-details__col-metric" />
              <col className="organic-post-details__col-metric" />
              <col className="organic-post-details__col-metric" />
              <col className="organic-post-details__col-action" />
            </colgroup>
            <thead>
              <tr>
                <th className="organic-post-details__th-post">
                  <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "caption"))}>
                    {t("organicMedia.instagram.table.post")?.toUpperCase()}
                  </DashboardDataTableSortButton>
                </th>
                <th className="organic-post-details__th-tooltip">
                  <span className={dt.thHelpRow}>
                    <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "impressions"))}>
                      {t("organicMedia.instagram.table.impressions")?.toUpperCase()}
                    </DashboardDataTableSortButton>
                    <DefinitionTooltip
                      label={t("organicMedia.instagram.table.impressions")}
                      info={getOrganicPlatformMetricDefinitionInfo("instagram", "impressions", t("organicMedia.instagram.table.impressions"), t)}
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </span>
                </th>
                <th className="organic-post-details__th-tooltip">
                  <span className={dt.thHelpRow}>
                    <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "reach"))}>
                      {t("organicMedia.instagram.table.reach")?.toUpperCase()}
                    </DashboardDataTableSortButton>
                    <DefinitionTooltip
                      label={t("organicMedia.instagram.table.reach")}
                      info={getOrganicPlatformMetricDefinitionInfo("instagram", "reach", t("organicMedia.instagram.table.reach"), t)}
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </span>
                </th>
                <th className="organic-post-details__th-tooltip">
                  <span className={dt.thHelpRow}>
                    <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "likes"))}>
                      {t("organicMedia.instagram.table.likes")?.toUpperCase()}
                    </DashboardDataTableSortButton>
                    <DefinitionTooltip
                      label={t("organicMedia.instagram.table.likes")}
                      info={getOrganicPlatformMetricDefinitionInfo("instagram", "likes", t("organicMedia.instagram.table.likes"), t)}
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </span>
                </th>
                <th className="organic-post-details__th-tooltip">
                  <span className={dt.thHelpRow}>
                    <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "comments"))}>
                      {t("organicMedia.instagram.table.comments")?.toUpperCase()}
                    </DashboardDataTableSortButton>
                    <DefinitionTooltip
                      label={t("organicMedia.instagram.table.comments")}
                      info={getOrganicPlatformMetricDefinitionInfo("instagram", "comments", t("organicMedia.instagram.table.comments"), t)}
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </span>
                </th>
                <th className="organic-post-details__th-tooltip">
                  <span className={dt.thHelpRow}>
                    <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "shares"))}>
                      {t("organicMedia.instagram.table.shares")?.toUpperCase()}
                    </DashboardDataTableSortButton>
                    <DefinitionTooltip
                      label={t("organicMedia.instagram.table.shares")}
                      info={getOrganicPlatformMetricDefinitionInfo("instagram", "shares", t("organicMedia.instagram.table.shares"), t)}
                      align="end"
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </span>
                </th>
                <th className="organic-post-details__th-tooltip">
                  <span className={dt.thHelpRow}>
                    <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "saves"))}>
                      {t("organicMedia.instagram.table.saves")?.toUpperCase()}
                    </DashboardDataTableSortButton>
                    <DefinitionTooltip
                      label={t("organicMedia.instagram.table.saves")}
                      info={getOrganicPlatformMetricDefinitionInfo("instagram", "saves", t("organicMedia.instagram.table.saves"), t)}
                      align="end"
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </span>
                </th>
                <th className="organic-post-details__th-tooltip">
                  <span className={dt.thHelpRow}>
                    <DashboardDataTableSortButton onClick={() => setPostTableSort(current => toggleTableSort(current, "engagementRate"))}>
                      {t("organicMedia.instagram.table.engRate")?.toUpperCase()}
                    </DashboardDataTableSortButton>
                    <DefinitionTooltip
                      label={t("organicMedia.instagram.table.engRate")}
                      info={getOrganicPlatformMetricDefinitionInfo("instagram", "engagementRate", t("organicMedia.instagram.table.engRate"), t)}
                      align="end"
                      formulaTitle={t("organicMedia.common.formula")}
                    />
                  </span>
                </th>
                <th>{t("organicMedia.instagram.table.link")?.toUpperCase()}</th>
              </tr>
            </thead>
            <tbody>
              {exportPostDetails.map((row, index) => (
                <tr key={`${row.postSystemId || row.caption}-${index}`}>
                  <td>
                    <div className="organic-post-details__post-cell">
                      <div className="organic-post-details__thumb" aria-hidden>
                        <PostMediaThumb thumbnailUrl={row.thumbnailUrl} platform="instagram" />
                      </div>
                      <div className="organic-post-details__post-copy">
                        <div className="organic-post-details__caption-wrap">
                          <strong>{truncateCaption(row.caption, 48)}</strong>
                          <div className="organic-post-details__caption-tooltip">{getCaptionPreview(row.caption)}</div>
                        </div>
                        <div className="organic-post-details__tag-row">
                          <span className="organic-post-details__mini-tag organic-post-details__mini-tag--platform">
                            {t("organicMedia.platform.instagram")}
                          </span>
                          <span className="organic-post-details__mini-tag organic-post-details__mini-tag--type">
                            {formatOrganicPostTypeLabel(row.postType, t)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{row.impressionsFormattedValue ?? formatNumber(row.impressions, {}, i18n.language)}</td>
                  <td>{row.reachFormattedValue ?? formatNumber(row.reach, {}, i18n.language)}</td>
                  <td>{row.likesFormattedValue ?? formatNumber(row.likes, {}, i18n.language)}</td>
                  <td>{row.commentsFormattedValue ?? formatNumber(row.comments, {}, i18n.language)}</td>
                  <td>{row.sharesFormattedValue ?? formatNumber(row.shares, {}, i18n.language)}</td>
                  <td>{row.savesFormattedValue ?? formatNumber(row.saves, {}, i18n.language)}</td>
                  <td>
                    {row.engagementRateFormattedValue ??
                      withBidiIsolate(
                        `${formatNumber(row.engagementRate, { minimumFractionDigits: 1, maximumFractionDigits: 1 }, i18n.language)}%`,
                        i18n.language
                      )}
                  </td>
                  <td className="organic-post-details__action-cell">
                    {row.postUrl ? (
                      <a
                        className="organic-post-details__action-button"
                        href={row.postUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <ExternalLink size={14} aria-hidden />
                        {t("organicMedia.instagram.table.viewPost")}
                      </a>
                    ) : (
                      <button
                        type="button"
                        className="organic-post-details__action-button"
                        disabled
                        title={t("organicMedia.contentReport.postLinkUnavailable")}
                      >
                        <ExternalLink size={14} aria-hidden />
                        {t("organicMedia.instagram.table.viewPost")}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </DashboardDataTableTable>
        </DashboardDataTableScroll>
        <TablePagePagination
          currentPage={currentPostPage}
          totalPages={totalPostPages}
          onPrevious={() => setCurrentPostPage(page => Math.max(1, page - 1))}
          onNext={() => setCurrentPostPage(page => Math.min(totalPostPages, page + 1))}
          className="organic-post-details__pager"
        />
        </DashboardDataTablePanel>
      </div>
    </div>
  );
};

export default InstagramContentPostTable;
